(() => {
  if (window.__norgiraRelatedReady) return;
  window.__norgiraRelatedReady = true;
  const cardSelector = '.nhp-related .product-card-wrapper[data-norgira-grid-card]';
  const controls = 'button,input,select,textarea,[role=button]';
  let contact = null;
  const closeCards = (keep = null) => document.querySelectorAll(cardSelector + '.is-options-open').forEach(card => {
    if (card !== keep) card.classList.remove('is-options-open');
  });
  const beginContact = (target, point) => {
    if (!(target instanceof Element)) return;
    const card = target.closest(cardSelector);
    if (!card) { closeCards(); contact = null; return; }
    if (target.closest(controls)) return;
    if (!target.closest('[data-norgira-grid-slide]') || !point) return;
    closeCards(card);
    card.classList.add('is-options-open');
    contact = { x: point.clientX, y: point.clientY };
  };
  const moveContact = point => {
    if (contact && point && Math.hypot(point.clientX - contact.x, point.clientY - contact.y) > 8) {
      closeCards(); contact = null;
    }
  };
  // Capture before the row stops touch propagation to the nested image carousel.
  // Never cancel a touch or click: a completed image tap follows its native link.
  document.addEventListener('touchstart', event => {
    if (event.touches.length !== 1) { closeCards(); contact = null; return; }
    beginContact(event.target, event.touches[0]);
  }, { capture: true, passive: true });
  document.addEventListener('touchmove', event => moveContact(event.touches[0]), { capture: true, passive: true });
  document.addEventListener('pointerdown', event => {
    if (event.pointerType === 'touch') beginContact(event.target, event);
  }, { capture: true, passive: true });
  document.addEventListener('pointermove', event => {
    if (event.pointerType === 'touch') moveContact(event);
  }, { capture: true, passive: true });
  const cancelContact = () => { closeCards(); contact = null; };
  document.addEventListener('touchcancel', cancelContact, { capture: true, passive: true });
  document.addEventListener('pointercancel', event => { if (event.pointerType === 'touch') cancelContact(); }, { capture: true, passive: true });
  document.addEventListener('scroll', cancelContact, { capture: true, passive: true });
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element) || !event.target.closest(cardSelector)) cancelContact();
  }, true);
  const setup = () => document.querySelectorAll('.nhp-related').forEach(root => {
    const list = root.querySelector('.product-grid');
    if (!list || list.dataset.nhpRelatedReady) return;
    list.dataset.nhpRelatedReady = 'true';
    list.tabIndex = 0;
    list.setAttribute('aria-label', root.dataset.carouselLabel || 'Related items');
    const previous = root.querySelector('[data-related-prev]'), next = root.querySelector('[data-related-next]');
    const update = () => { if(previous)previous.disabled = list.scrollLeft < 2;if(next)next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2; };
    const move = direction => {const card=list.querySelector('.grid__item');const step=innerWidth<768?card.getBoundingClientRect().width:list.clientWidth-40;list.scrollBy({left:direction*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
    previous?.addEventListener('click',()=>move(-1));next?.addEventListener('click',()=>move(1));
    list.addEventListener('scroll',update,{passive:true});
    list.addEventListener('keydown',event=>{if(event.target!==list)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
    // Swiping here moves the recommendation row, not the nested product image gallery.
    list.addEventListener('touchstart',event=>event.stopPropagation(),{capture:true,passive:true});
    list.addEventListener('touchend',event=>event.stopPropagation(),{capture:true,passive:true});
    let pointer=null,dragged=false;
    list.addEventListener('pointerdown',event=>{if(event.pointerType!=='mouse'||event.button!==0||event.target.closest('button'))return;pointer={id:event.pointerId,x:event.clientX,left:list.scrollLeft};dragged=false;});
    list.addEventListener('pointermove',event=>{if(!pointer)return;const delta=event.clientX-pointer.x;if(Math.abs(delta)>6){dragged=true;list.setPointerCapture(pointer.id);list.classList.add('is-dragging');list.scrollLeft=pointer.left-delta;event.preventDefault();}});
    const end=()=>{pointer=null;list.classList.remove('is-dragging');};list.addEventListener('pointerup',end);list.addEventListener('pointercancel',end);
    list.addEventListener('click',event=>{if(dragged){event.preventDefault();event.stopPropagation();dragged=false;}},true);
    new ResizeObserver(update).observe(list);update();
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
  new MutationObserver(setup).observe(document.documentElement,{subtree:true,childList:true});
})();
